// extracted by mini-css-extract-plugin
export default {"main":"empty_main__nO2r0","price":"empty_price__HN7ui"};